export class MathUtils {
  /**
   * Computes the RMS for a given array of numeric values.
   *
   * @param {Array<Number>} arr An array of numeric values
   * @param {Number} startIndex (optional) index to start from (inclusive)
   * @param {Number} endIndex (optional) index to end (not inclusive)
   * @returns {Number}
   */
  public static getRootMeanSquared(arr: number[] | Float32Array, startIndex = 0, endIndex: number = arr.length): number {
    let rms = 0

    for (let i = startIndex; i < endIndex; i++) {
      rms += arr[i] * arr[i]
    }

    rms /= endIndex - startIndex
    rms = Math.sqrt(rms)

    return rms
  }

  public static sum(arr: number[]): number {
    return arr.reduce((p, c) => p + c, 0)
  }

  public static average(arr: number[]): number | undefined {
    if (arr.length === 0) return undefined

    return MathUtils.sum(arr) / arr.length
  }

  public static isBetween(value: number, from: number, to: number): boolean {
    return (value >= from && value <= to) || (value >= to && value <= from)
  }
}
